<template>
  <div class="login-container">
    <!-- 语言切换（右上角悬浮） -->
    <div class="lang-box">
      <el-select
        :placeholder="$t('login.choiceLang')"
        v-model="loginForm.language"
        @change="choiceLang"
      >
        <el-option
          v-for="item in langArr"
          :key="item.label"
          :label="item.name"
          :value="item.label"
        ></el-option>
      </el-select>
    </div>

    <div class="login-card">
      <div class="brand">
        <h3 class="title">{{$t('login.login')}}</h3>
        <div class="brand-line"></div>
      </div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <el-form-item prop="username">
          <el-input
            ref="username"
            v-model="loginForm.username"
            :placeholder="$t('user.loginName')"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <el-form-item prop="password" class="pwd-item">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            :placeholder="$t('login.password')"
            name="password"
            tabindex="2"
            auto-complete="on"
            prefix-icon="el-icon-lock"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>

        <el-button
          :loading="loading"
          type="primary"
          class="login-btn"
          @click.native.prevent="handleLogin"
        >{{$t('login.login')}}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { localSave, localRead} from '@/utils/tools'
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        model: "",
        otp: "123456",
        language: this.$i18n.locale
      },
      projectArr: [], //可选择的项目集合
      projectArrAll: [], //所有项目集合
      langArr:[
        // {label:'en_US',name:"English"},
        {label:'zh_CN',name:"简体中文"}
        // {label:'vi_VN',name:"Tiếng Việt"}
      ],
      loading: false,
      passwordType: "password",
      redirect: undefined
    };
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() { this.loading = true;
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              if(!localRead("language")){
                localSave("language",'zh_CN')
              }
              if (localRead('model') == -1) {
                this.$router.push({ path: '/' })
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
    },
    choiceLang(val){
      this.$i18n.locale = val
      localSave("language",val)
    }
  },
};
</script>

<style lang="scss">
/* 登录页：浅色青调渐变 + 白色卡片（与后台金融青主色 #007A6A 一致） */

.login-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #EFF7F4;
  background-image:
    radial-gradient(1100px 600px at 8% -8%, rgba(0, 122, 106, 0.16), transparent 55%),
    radial-gradient(900px 520px at 104% 6%, rgba(0, 141, 120, 0.12), transparent 52%),
    linear-gradient(155deg, #E9F4F0 0%, #F8FBFA 46%, #EFF6F3 100%);
}

/* 右上角语言切换（浅色胶囊） */
.lang-box {
  position: absolute;
  top: 20px;
  right: 26px;
  z-index: 10;

  .el-select {
    width: 130px;
  }

  .el-input__inner {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: #0B3B33;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(0, 122, 106, 0.22);
    border-radius: 18px;
    padding-left: 14px;
  }
}

/* 中央登录卡片 */
.login-card {
  width: 400px;
  max-width: 92vw;
  background: #fff;
  border: 1px solid #E8ECF2;
  border-radius: 14px;
  padding: 42px 40px 34px;
  box-shadow: 0 18px 50px rgba(6, 78, 66, 0.12), 0 2px 10px rgba(6, 78, 66, 0.06);
}

.brand {
  margin-bottom: 28px;

  .title {
    margin: 0;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: #0B3B33;
    letter-spacing: 2px;
  }

  .brand-line {
    width: 40px;
    height: 3px;
    margin: 12px auto 0;
    border-radius: 2px;
    background: linear-gradient(90deg, #007A6A, #0BA38B);
  }
}

/* 表单控件 */
.login-form {
  .el-form-item {
    margin-bottom: 20px;
  }

  .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: 13px;
    color: #303133;
    background: #FBFDFC;
    border: 1px solid #DCE4E8;
    border-radius: 8px;
    padding-left: 40px;
    transition: border-color 0.2s, box-shadow 0.2s, background-color 0.2s;
  }

  .el-input__inner:hover {
    border-color: #B8D6CF;
  }

  .el-input__inner:focus {
    background: #fff;
    border-color: #007A6A;
    box-shadow: 0 0 0 3px rgba(0, 122, 106, 0.12);
  }

  .el-input__prefix {
    left: 12px;
    font-size: 16px;
    color: #8A98A8;
    transition: color 0.2s;
  }

  .el-input.is-focus .el-input__prefix {
    color: #007A6A;
  }

  .pwd-item .el-input__inner {
    padding-right: 38px;
  }
}

/* 显示/隐藏密码 */
.pwd-item {
  position: relative;

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    font-size: 15px;
    color: #8A98A8;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: #007A6A;
    }
  }
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 42px;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 4px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(90deg, #007A6A 0%, #0B8E7A 100%);
  box-shadow: 0 8px 18px rgba(0, 122, 106, 0.28);

  &:hover,
  &:focus {
    background: linear-gradient(90deg, #00695C 0%, #0A7E6C 100%);
    opacity: 1;
  }

  &:active {
    transform: translateY(1px);
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 34px 24px 24px;
  }

  .lang-box {
    top: 12px;
    right: 12px;
  }
}
</style>
